import React, {Component} from 'react';
import "./ShafafiyaRegistration.css";
import PrimeDateRangeInput from "../../../../components/date-input/PrimeDateRangeInput";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import PageTitle from "../../../../layout/PageTitle";
import DateUtil from "../../../../utils/DateUtil";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import {Button, ButtonGroup, Image} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Badge, NavLink, SelectInput, XmlPreviewModal} from "../../../../components";
import EnumGender from "../../../../enums/EnumGender";
import PatientUtil from "../../../../utils/PatientUtil";
import StringUtil from "../../../../utils/StringUtil";
import confirmDialog from "../../../../components/dialog/ConfirmDialog";
import dialog from "../../../../components/dialog/Dialog";
import ShafafiyaTransactionLogModal from "../v2/claims/ShafafiyaTransactionLogModal";
import NotificationService from "../../../../services/notification-service/NotificationService";
import Tooltip from "../../../../components/tooltip/Tooltip";

export default class ShafafiyaRegistration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            selectedRows: [],
            selectedDate: new Date(),
            genderFilterVal: null,
            insuranceFilterVal: null,
            shafafiyaFilterVal: null,
            showErrorDialog: false,
            errorDialogMessage: '',
            errorDialogDetails: null,
            showPreviewModal: false,
            previewXml: '',
            showReadinessModal: false,
            readinessByAppointmentId: {},
            readinessFocusAppointmentId: null
        };
    }

    componentDidMount() {
        if (this.props.selected) {
            this.retrieveAppointments();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.selected && this.props.selected) {
            this.retrieveAppointments();
        }
    }

    handleDateChange = (date) => {
        // Date change invalidates the multi-select used for XML generation
        this.setState({selectedDate: date, selectedRows: []}, () => {
            if (date) {
                this.retrieveAppointments();
            }
        });
    }

    shiftSelectedDate = (days) => {
        this.handleDateChange(DateUtil.addDays(this.state.selectedDate || new Date(), days));
    }

    retrieveAppointments() {
        const date = this.state.selectedDate;
        if (!date) {
            return;
        }
        const startOfDay = new Date(date);
        startOfDay.setHours(0, 0, 0, 0);

        const endOfDay = new Date(date); // TODO no need for timezone adjustment for now
        endOfDay.setHours(23, 59, 59, 999);

        const params = {
            startTime: startOfDay.toISOString(),
            endTime: endOfDay.toISOString(),
            staffIds: []
        };

        RemotingService.getRemoteCall('api/appointment/list', params, (result) => {
            const appointments = result.items.filter(a => a.status === 'CONSULTED' || a.status === 'COMPLETED');
            const mappedAppointments = appointments.map((appointment) => {
                const mapped = {...appointment};
                mapped.dob = appointment.patient.birthday ? DateUtil.formatDate(appointment.patient.birthday, "DD-MMM-YYYY") : '-';
                mapped.patientName = PatientUtil.getPatientsName(appointment.patient);
                mapped.shafafiyaFilterStatus = appointment.shafafiyaStatus || 'NOT_SENT';
                return mapped;
            });
            this.setState({items: mappedAppointments, readinessByAppointmentId: {}}, () => {
                this.loadReadinessForVisibleAppointments();
            });
        });
    }

    loadReadinessForVisibleAppointments = () => {
        const ids = this.state.items.map(i => i.id);
        if (ids.length === 0) return;
        RemotingService.getRemoteCall("api/shafafiya/person/readiness-check?ids=" + ids.join(','), null, (results) => {
            const byId = {};
            (results || []).forEach(r => { byId[r.appointmentId] = r.fields || []; });
            this.setState({readinessByAppointmentId: byId});
        });
    }

    handleSelectionChange = (e) => {
        if (e.value.some(row => row.shafafiyaStatus === 'SUBMITTED')) {
            NotificationService.showNotification({
                severity: 'warn',
                summary: 'Already Submitted',
                detail: 'Some appointments were already successfully submitted to Shafafiya.'
            });
        }
        const filteredSelection = e.value.filter(row => row.shafafiyaStatus !== 'SUBMITTED');
        this.setState({selectedRows: filteredSelection});
    }

    handlePreviewXmlClick = () => {
        if (this.state.selectedRows.length === 0) return;
        const appointmentIds = this.state.selectedRows.map(a => a.id);
        RemotingService.getRemoteCall("api/shafafiya/person/xml?ids=" + appointmentIds.join(','), null, (xmlText) => {
            this.setState({showPreviewModal: true, previewXml: xmlText});
        });
    }

    handleReadinessCheckClick = () => {
        if (this.state.selectedRows.length === 0) return;
        const appointmentIds = this.state.selectedRows.map(a => a.id);
        RemotingService.getRemoteCall("api/shafafiya/person/readiness-check?ids=" + appointmentIds.join(','), null, (results) => {
            const updated = {...this.state.readinessByAppointmentId};
            (results || []).forEach(r => { updated[r.appointmentId] = r.fields || []; });
            this.setState({
                readinessByAppointmentId: updated,
                showReadinessModal: true,
                readinessFocusAppointmentId: null
            });
        });
    }

    openReadinessForAppointment = (appointmentId) => {
        const row = this.state.items.find(i => i.id === appointmentId);
        const alreadySelected = this.state.selectedRows.some(r => r.id === appointmentId);
        const nextSelection = (!alreadySelected && row && row.shafafiyaStatus !== 'SUBMITTED')
            ? [...this.state.selectedRows, row]
            : this.state.selectedRows;
        this.setState({
            showReadinessModal: true,
            readinessFocusAppointmentId: appointmentId,
            selectedRows: nextSelection
        });
    }

    hidePreviewModal = () => this.setState({showPreviewModal: false, previewXml: ''});

    hideReadinessModal = () => this.setState({showReadinessModal: false, readinessFocusAppointmentId: null});

    handleSendXmlClick = () => {
        if (this.state.selectedRows.length > 0) {
            const appointmentIds = this.state.selectedRows.map(row => row.id);

            const rowsWithIssues = this.state.selectedRows.filter(row => {
                const fields = this.state.readinessByAppointmentId[row.id] || [];
                return fields.some(f => !f.valid);
            });
            const message = rowsWithIssues.length > 0
                ? `${rowsWithIssues.length} of ${appointmentIds.length} selected patient(s) have validation errors and will likely be rejected by Shafafiya. Are you sure you want to send the XML?`
                : `Are you sure you want to submit ${appointmentIds.length} appointment(s) to Shafafiya?`;

            confirmDialog(
                "Submit to Shafafiya",
                message,
                () => {
                    RemotingService.postRemoteCall("api/shafafiya/person/xml?ids=" + appointmentIds.join(','), null, (result) => {
                        if (result.success) {
                            NotificationService.showNotification({
                                severity: 'success',
                                summary: 'Success',
                                detail: result.message
                            });
                        } else {
                            this.setState({
                                showErrorDialog: true,
                                errorDialogMessage: result.message,
                                errorDialogDetails: result.errorDetails
                            });
                        }
                        this.setState({selectedRows: [], showPreviewModal: false, previewXml: ''});
                        this.retrieveAppointments();
                    });
                }
            );
        }
    }

    openTransactionLogModal = () => {
        dialog({
            title: "Shafafiya Transaction History",
            component: <ShafafiyaTransactionLogModal url="api/shafafiya/person/transaction-log" mrnFilter/>
        });
    }

    hideErrorDialog = () => {
        this.setState({
            showErrorDialog: false,
            errorDialogMessage: '',
            errorDialogDetails: null
        });
    }

    patientNameTemplate = (rowData) => {
        let photoSrc = process.env.PUBLIC_URL + '/assets/patient_profile.png';
        if (rowData.patient.thumbnail) {
            photoSrc = 'data:image/jpeg;base64,' + rowData.patient.thumbnail;
        }
        const fields = this.state.readinessByAppointmentId[rowData.id];
        const invalidCount = Array.isArray(fields) ? fields.filter(f => !f.valid).length : 0;
        return (
            <div className="d-flex flex-row align-items-center">
                <Image src={photoSrc} rounded width={"40px"} style={{paddingRight: 5}}/>
                <NavLink to={'/patientdetail/' + rowData.patient.id}>{rowData.patientName}</NavLink>
                {invalidCount > 0 && (
                    <Tooltip title={`${invalidCount} validation issue(s) — click for details`}>
                        <FontAwesomeIcon
                            icon="exclamation-triangle"
                            className="text-danger ml-2"
                            style={{cursor: 'pointer'}}
                            onClick={() => this.openReadinessForAppointment(rowData.id)}
                        />
                    </Tooltip>
                )}
            </div>
        );
    }

    staffNameTemplate = (rowData) => {
        return (<NavLink to={'/staffprofile/' + rowData.staff.id}>{rowData.staff.name}</NavLink>);
    }

    genderTemplate = (rowData) => {
        return <>{EnumGender[rowData.patient.gender]}</>;
    }

    nationalityTemplate = (rowData) => {
        return (rowData.patient.lookupNationality && rowData.patient.lookupNationality.description) || '-';
    }

    eidTemplate = (rowData) => {
        return rowData.patient.eid || '-';
    }

    appointmentStatusTemplate = (rowData) => {
        if (!rowData.status) return '-';
        return rowData.status.charAt(0) + rowData.status.slice(1).toLowerCase();
    }

    mrnTemplate = (rowData) => {
        return StringUtil.mrn(rowData.patient.mrn);
    }

    insuranceTemplate = (rowData) => {
        return rowData.insuranceExists ? 'Yes' : 'No';
    }

    shafafiyaStatusTemplate = (rowData) => {
        if (rowData.shafafiyaStatus === 'REJECTED') {
            return (
                <Tooltip title={rowData.shafafiyaRejectionReason}>
                    <Badge
                        className="TableColBadge"
                        style={{backgroundColor: "orange", color: "white", paddingTop: 6, paddingBottom: 11}}
                    >
                        Rejected
                    </Badge>
                </Tooltip>
            );
        }
        if (rowData.shafafiyaStatus === 'SUBMITTED') {
            return <Badge className="TableColBadge" style={{backgroundColor: "green", color: "white", paddingTop: 6, paddingBottom: 11}}>Sent</Badge>;
        }
        return <Badge className="TableColBadge" style={{backgroundColor: "red", color: "white", paddingTop: 6, paddingBottom: 11}}>Pending</Badge>;
    }

    onGenderFilterChange = (val) => {
        this.dataTableRef.filter(val, 'patient.gender', 'equals');
        this.setState({genderFilterVal: val});
    }

    onInsuranceFilterChange = (val) => {
        this.dataTableRef.filter(val, 'insuranceExists', 'equals');
        this.setState({insuranceFilterVal: val});
    }

    onShafafiyaFilterChange = (val) => {
        this.dataTableRef.filter(val, 'shafafiyaFilterStatus', 'equals');
        this.setState({shafafiyaFilterVal: val});
    }

    render() {
        const {selectedRows} = this.state;
        const patientsSelected = selectedRows.length > 0;

        const genderFilter = (
            <SelectInput className="w-100" value={this.state.genderFilterVal}
                         options={EnumGender.toArray()}
                         displayProperty="name" valueProperty="key" searchEnabled={false}
                         onChange={(val) => this.onGenderFilterChange(val)}/>
        );

        const insuranceFilter = (
            <SelectInput className="w-100" value={this.state.insuranceFilterVal}
                         options={[{key: false, name: "No"}, {key: true, name: "Yes"}]}
                         displayProperty="name" valueProperty="key" searchEnabled={false}
                         onChange={(val) => this.onInsuranceFilterChange(val)}/>
        );

        const shafafiyaFilter = (
            <SelectInput className="w-100" value={this.state.shafafiyaFilterVal}
                         options={[{key: 'NOT_SENT', name: "Pending"}, {key: 'SUBMITTED', name: "Sent"}, {key: 'REJECTED', name: "Rejected"}]}
                         displayProperty="name" valueProperty="key" searchEnabled={false}
                         onChange={(val) => this.onShafafiyaFilterChange(val)}/>
        );

        const focusId = this.state.readinessFocusAppointmentId;
        const readinessRows = focusId
            ? this.state.items.filter(r => r.id === focusId)
            : this.state.selectedRows;

        return (
            <>
                <Dialog
                    header="Shafafiya Submission Error"
                    visible={this.state.showErrorDialog}
                    style={{width: '50vw'}}
                    onHide={this.hideErrorDialog}
                    dismissableMask={true}
                >
                    <div className="p-3">
                        <p className="text-danger font-weight-bold">{this.state.errorDialogMessage}</p>
                        {this.state.errorDialogDetails && (
                            <div className="mt-3">
                                <strong>Error Details:</strong>
                                <pre style={{
                                    backgroundColor: '#f5f5f5',
                                    padding: '10px',
                                    marginTop: '10px',
                                    borderRadius: '4px',
                                    maxHeight: '300px',
                                    overflow: 'auto',
                                    fontSize: '12px',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {this.state.errorDialogDetails}
                                </pre>
                            </div>
                        )}
                    </div>
                </Dialog>

                <XmlPreviewModal
                    visible={this.state.showPreviewModal}
                    header="Person Register XML Preview"
                    xml={this.state.previewXml}
                    readOnly
                    downloadFilename={`PersonRegister_${DateUtil.formatDate(new Date(), 'YYYYMMDD_HHmmss')}.xml`}
                    onSubmit={this.handleSendXmlClick}
                    onClose={this.hidePreviewModal}
                />

                <Dialog
                    header="Patient Register Validation Check"
                    visible={this.state.showReadinessModal}
                    style={{width: '60vw'}}
                    onHide={this.hideReadinessModal}
                    dismissableMask={true}
                >
                    <div className="p-3">
                        {readinessRows.length === 0 && (
                            <p className="text-muted">No patients selected.</p>
                        )}
                        {readinessRows.map(row => {
                            const fields = this.state.readinessByAppointmentId[row.id] || [];
                            const invalidCount = fields.filter(f => !f.valid).length;
                            return (
                                <div key={row.id} className="mb-4">
                                    <div>
                                        <strong>{row.patientName}</strong>
                                        <span className="text-muted ml-2">(MRN {StringUtil.mrn(row.patient.mrn)})</span>
                                        {fields.length > 0 && (
                                            <span className={`ml-2 small ${invalidCount === 0 ? 'text-success' : 'text-danger'}`}>
                                                {invalidCount === 0
                                                    ? `All ${fields.length} checks passed`
                                                    : `${invalidCount} of ${fields.length} checks failed`}
                                            </span>
                                        )}
                                    </div>
                                    {fields.length > 0 && (
                                        <ul className="mt-1 mb-0" style={{listStyle: 'none', paddingLeft: 0}}>
                                            {fields.map((f, idx) => (
                                                <li key={idx} className={f.valid ? 'text-success' : 'text-danger'} style={{padding: '2px 0'}}>
                                                    <FontAwesomeIcon icon={f.valid ? 'check' : 'times'}/>
                                                    <strong className="ml-2">{f.label}:</strong>
                                                    <span className="ml-1">
                                                        {f.value
                                                            ? f.value
                                                            : <em className="text-muted">(empty)</em>}
                                                    </span>
                                                    {!f.valid && (
                                                        <div className="text-muted small ml-4" style={{fontStyle: 'italic'}}>
                                                            {f.message}
                                                        </div>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </Dialog>

                <div style={{padding: '10px'}} className="data-table-header-wrapper">
                    <div className="float-left">
                        <PageTitle title="Shafafiya Patient Register" className="bg-white"/>
                    </div>
                    <div className="float-right d-flex" style={{gap: "10px"}}>
                        <ButtonGroup style={{height: "fit-content"}}>
                            <Button variant="outline-secondary" onClick={() => this.shiftSelectedDate(-1)}>
                                Back
                            </Button>
                            <Button variant="outline-secondary"
                                    active={DateUtil.isToday(this.state.selectedDate)}
                                    onClick={() => this.handleDateChange(new Date())}>
                                Today
                            </Button>
                            <Button variant="outline-secondary" onClick={() => this.shiftSelectedDate(1)}>
                                Next
                            </Button>
                        </ButtonGroup>
                        <PrimeDateRangeInput single value={this.state.selectedDate}
                                             onChange={this.handleDateChange}/>
                    </div>
                </div>

                <div style={{padding: '10px'}}>
                    <div className="d-flex justify-content-between mb-2">
                        <Button
                            style={{height: "fit-content"}}
                            variant={patientsSelected ? "warning" : "secondary"}
                            onClick={this.handleReadinessCheckClick}
                            disabled={!patientsSelected}
                        >
                            <FontAwesomeIcon icon="check-double"/> Validation Check
                        </Button>
                        <div className="d-flex">
                            <Button
                                style={{height: "fit-content", marginRight: "10px"}}
                                variant="light"
                                onClick={this.openTransactionLogModal}
                            >
                                <FontAwesomeIcon icon="history"/> Transaction Log
                            </Button>
                            <Button
                                style={{height: "fit-content"}}
                                variant="primary"
                                onClick={this.handlePreviewXmlClick}
                                disabled={!patientsSelected}
                            >
                                <FontAwesomeIcon icon="eye"/> Preview XML
                            </Button>
                            <Button
                                style={{height: "fit-content", marginLeft: "10px"}}
                                variant="success"
                                onClick={this.handleSendXmlClick}
                                disabled={!patientsSelected}
                            >
                                <FontAwesomeIcon icon="upload"/> Send XML
                            </Button>
                        </div>
                    </div>

                    <DataTable
                        className="ShafafiyaTable"
                        ref={(el) => this.dataTableRef = el}
                        value={this.state.items}
                        emptyMessage={"No appointments found for selected date"}
                        rows={20}
                        scrollable
                        paginator={true}
                        paginatorPosition="bottom"
                        selection={this.state.selectedRows}
                        onSelectionChange={this.handleSelectionChange}
                        dataKey="id"
                    >
                        <Column selectionMode="multiple" style={{width: '3em'}}/>
                        <Column header="Appointment Status" field="status" body={this.appointmentStatusTemplate}
                                sortable style={{width: '140px'}}/>
                        <Column header="MRN" field="patient.mrn.mrnNo" body={this.mrnTemplate}
                                filter={true} filterMatchMode="contains" sortable style={{width: '80px'}}/>
                        <Column header="Patient Name" field="patientName" body={this.patientNameTemplate}
                                filter={true} filterMatchMode="contains" sortable style={{width: '250px'}}/>
                        <Column header="DOB" field="dob" sortable style={{width: '110px'}}/>
                        <Column header="Gender" field="patient.gender" body={this.genderTemplate}
                                filter={true} filterElement={genderFilter} sortable style={{width: '180px'}}/>
                        <Column header="Nationality" field="patient.lookupNationality.description"
                                body={this.nationalityTemplate}
                                filter={true} filterMatchMode="contains" sortable style={{width: '120px'}}/>
                        <Column header="Emirates ID" field="patient.eid" body={this.eidTemplate}
                                filter={true} filterMatchMode="contains" style={{width: '160px'}}/>
                        <Column header="Mobile" field="patient.mobilePhone"
                                filter={true} filterMatchMode="contains" style={{width: '120px'}}/>
                        <Column header="Insurance" field="insuranceExists" body={this.insuranceTemplate}
                                filter={true} filterElement={insuranceFilter} sortable style={{width: '80px'}}/>
                        <Column header="Provider" field="staff.name" body={this.staffNameTemplate}
                                filter={true} filterMatchMode="contains" sortable style={{width: '150px'}}/>
                        <Column header="Status" field="shafafiyaFilterStatus" body={this.shafafiyaStatusTemplate}
                                filter={true} filterElement={shafafiyaFilter} style={{width: '100px'}}/>
                    </DataTable>
                </div>
            </>
        );
    }
}
